<template>
  <label
    :for="cpa"
    class="tw:hover:cursor-pointer tw:border-2 tw:hover:bg-blue-100 tw:flex tw:flex-col tw:sm:flex-row tw:md:flex-col tw:lg:flex-row tw:w-full shadow tw:rounded-xl tw:py-3 tw:pl-6 tw:pr-3 tw:mb-0 tw:min-h-[90px] tw:items-center tw:relative"
    :class="
      isSelected
        ? ' tw:border-blue-700 tw:bg-blue-100 tw:justify-between tw:gap-x-4'
        : 'tw:border-transparent tw:bg-white'
    "
  >
    <div
      v-if="isCurrent"
      class="tw:bg-blue-700 tw:absolute tw:bottom-[-1px] tw:right-[-1px] tw:text-white tw:font-bold tw:py-1 tw:px-2 tw:text-xs tw:rounded-tl-xl tw:rounded-br-lg"
    >
      {{ $t('rc_opportunities_current_commission') }}
    </div>
    <div
      class="tw:flex tw:items-center tw:w-full"
      :class="{ 'tw:py-4 tw:sm:py-0 tw:md:py-4 tw:xl:py-0': cpa === currentCommissionLevel }"
    >
      <input
        type="radio"
        :value="cpa"
        :id="cpa"
        :checked="isSelected"
        @change="onChange(cpa)"
        class="tw:cursor-pointer tw:mr-4 tw:mb-1"
      />
      <div class="tw:w-full">
        <p class="tw:text-[20px] tw:leading-[25px] tw:font-bold tw:pb-1">
          {{ $t(commissionLabel) }}
        </p>
        <div
          class="tw:flex tw:xl:flex-row tw:flex-col tw:sm:flex-row tw:md:flex-col tw:items-start tw:md:items-start tw:sm:items-center tw:xl:items-center tw:gap-x-2 tw:text-[12px] tw:leading-[15px] tw:sm:text-[14px] tw:sm:leading-[20px] tw:md:text-[12px] tw:md:leading-[15px] tw:xl:text-[14px] tw:xl:leading-[20px]"
          v-if="cpa !== currentCommissionLevel"
        >
          <p>
            {{
              isVariationNegative
                ? $t('rc_opportunities_commission_decrease')
                : $t('rc_opportunities_commission_increase')
            }}
          </p>
          <div
            class="tw:text-[14px] tw:leading-[14px] tw:sm:text-[16px] tw:sm:leading-[16px] tw:md:text-[14px] tw:md:leading-[14px] tw:xl:text-[16px] tw:xl:leading-[16px] tw:gap-x-1 tw:font-bold tw:bg-white tw:flex tw:justify-center tw:items-center tw:border tw:border-gray-300 tw:rounded-md tw:py-1 tw:px-2 tw:mt-1 tw:sm:mt-0 tw:md:mt-1 tw:xl:mt-0"
          >
            <ArrowDownRight v-if="isVariationNegative" class="tw:size-[11px]" />
            <ArrowUpRight v-else class="tw:size-[11px]" />

            {{ getFormattedPercentage() }}
          </div>
        </div>
        <div
          v-if="!isCurrent && isSelected"
          class="tw:flex tw:mt-3 tw:sm:hidden tw:sm:mt-0 tw:lg:hidden tw:lg:mt-0 tw:md:flex tw:md:mt-3"
        >
          <MainButton @click="onSelect" class="tw:w-full tw:sm:w-auto tw:md:w-full tw:lg:w-auto">{{
            $t('rc_opportunities_commission_cta')
          }}</MainButton>
        </div>
      </div>
    </div>
    <div
      v-if="!isCurrent && isSelected"
      class="tw:hidden tw:mt-3 tw:sm:flex tw:sm:mt-0 tw:lg:flex tw:lg:mt-0 tw:md:hidden tw:md:mt-3"
    >
      <MainButton @click="onSelect" class="tw:w-full tw:sm:w-auto tw:md:w-full tw:lg:w-auto">
        {{ $t('rc_opportunities_commission_cta') }}
      </MainButton>
    </div>
  </label>
</template>
<script setup>
import { computed } from 'vue'

import MainButton from '@/components/base/buttons/MainButton.vue'
import ArrowUpRight from '@/components/icons/ArrowUpRight.svg?component'
import ArrowDownRight from '@/components/icons/ArrowDownRight.svg?component'

import { useSessionValues } from '@/composables/useSessionValues'

const props = defineProps({
  cpa: Number,
  variation: Number,
  currentCommissionLevel: String,
  selectedCommissionLevel: String,
  loading: Boolean,
})

const emit = defineEmits(['onChange', 'onSelect'])
const onChange = newCpa => emit('onChange', newCpa)
const onSelect = () => emit('onSelect')
const { language } = useSessionValues()
const commissionLabel = computed(() => {
  if (props.cpa === 10) return 'rc_opportunities_commission_10'
  if (props.cpa === 12) return 'rc_opportunities_commission_12'
  if (props.cpa === 15) return 'rc_opportunities_commission_15'
  if (props.cpa === 18) return 'rc_opportunities_commission_18'
  if (props.cpa === 20) return 'rc_opportunities_commission_20'
  if (props.cpa === 25) return 'rc_opportunities_commission_25'
  else return ''
})

const isSelected = computed(() => props.cpa === props.selectedCommissionLevel)
const isCurrent = computed(() => props.cpa === props.currentCommissionLevel)
const isVariationNegative = computed(() => props.variation < 0)
const getFormattedPercentage = () => {
  let newVariation = Intl.NumberFormat(language.value, { style: 'percent' }).format(props.variation / 100)
  if (language.value === 'de-DE' || language.value === 'es-ES' || language.value === 'fr-FE') {
    newVariation = newVariation.slice(0, -1) + ' %'
  }

  return newVariation
}
</script>
